import { Component, OnInit } from '@angular/core';
import { MenuComponent } from '../menu/menu.component';
import { ContenidoService } from '../contenido.service';

@Component({
  selector: 'app-ry-destination',
  templateUrl: './ry-destination.component.html',
  styleUrls: [
    '../../assets/css/bootstrap.min.css',
    '../../assets/scss/styles.scss', 
    '../../assets/scss/royal.scss', 
    '../../assets/scss/fonts.scss',
    './ry-destination.component.css',
    '../../assets/ema/main.scss',
    ]
})
export class RyDestinationComponent implements OnInit {
  public contenido = this.contenidoService.getContenido("ry-destination");
  constructor(private contenidoService: ContenidoService) {}

  ngOnInit() {
  }

}
